import * as React from 'react';
// eslint-disable-next-line react/no-deprecated
import { render, unmountComponentAtNode } from 'react-dom';
import { Ticker } from '../Ticker';

/**
 * @description Функция используется для добавления разных элементов для html баннеров. Своего рода костыль,
 * который позволяет более гибко настраивать наши html баннеры. Это на самом деле работа людей, которые предоставляют
 * эти баннеры в админку adfox, но они то что-то забудут, то им сложно, поэтому решили на такую хитрость пойти, что бы
 * и штрафов за маркировку не было (некорректную или отсутствие). Так же саму маркировку наши специалисты смогут быстро
 * поменять, а не ждать, пока дизайнеры поменяют картинку из-за маркировки
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function insertElementsToHTMLBanner(bundleParams, containerId) {
  var annotationElement = null;
  if (bundleParams.adLabelText) {
    var element = document.getElementById(containerId);
    if (element) {
      element.style.position = 'relative';

      /**
       * @description тут забавная вещь, у нас есть два поля adLabelText и adText, поле adText больше нам подходит
       * по семантике для этих целей, но мы его не можем использовать, так как у него ограничение в символах.
       */
      if (bundleParams.adLabelText) {
        annotationElement = document.createElement('div');
        annotationElement.style.zIndex = '1';
        annotationElement.style.position = 'absolute';
        annotationElement.style.bottom = '0';
        annotationElement.style.left = '0';
        annotationElement.style.width = '100%';
        annotationElement.style.overflowX = 'hidden';
        element.prepend(annotationElement);

        /**
         * @description Тут используется render так как не все мкс переехали на 18+ реакт,
         * а в 16 реакте нет нового способа для рендера компонентов
         */
        render(/*#__PURE__*/_jsx(Ticker, {
          text: bundleParams.adLabelText,
          withBackground: true
        }), annotationElement);
      }
    }
  }
  return function () {
    if (annotationElement) {
      /**
       * @description Тут используется unmountComponentAtNode так как не все мкс переехали на 18+ реакт,
       * а в 16 реакте нет нового способа для рендера компонентов
       */
      unmountComponentAtNode(annotationElement);
    }
  };
}